import Logger from 'config/logging';
import ActivityTemplateApi from 'api/activityTemplateApi';
import { TEMPLATE_MAPPER as types } from 'actions/actionTypes';

export const loadActivityTemplateSuccess = template => ({
  type: types.LOADED_TEMPLATE_SUCCESS,
  ActivityTemplate: template.toJS()
});

export const loadingInProgress = () => ({ type: types.LOADING_IN_PROGRESS });

export const loadActivityTemplate = template_id => (dispatch) => {
  dispatch(loadingInProgress());
  return ActivityTemplateApi.getActivityTemplate({ id: template_id })
    .then((response) => {
      dispatch(loadActivityTemplateSuccess(response.data));
    })
    .catch((error) => {
      Logger.error(`Error loading activity template - ${String(error)}`);
      dispatch({ type: types.LOADING_FAILED });
      throw error;
    });
};

export const addRosterEventDetails = (insertTime, insertGroupId, users, selectedTemplate) => ({
  type: types.ADD_ROSTER_EVENT_DETAILS,
  insertTime,
  insertGroupId,
  users,
  selectedTemplate
});

export const assignUserToPlaceHolder = (user, placeHolderGroupId) => ({
  type: types.ASSIGN_USER_TO_PLACEHOLDER,
  user,
  placeHolderGroupId
});

export const removeAssignedUserFromPlaceHolder = placeHolderGroupId => ({
  type: types.REMOVE_ASSIGNED_USER,
  placeHolderGroupId
});

export const reorderAssignedUser = (fromGroupId, toGroupId) => ({
  type: types.REORDER_ASSIGNED_USER,
  fromGroupId,
  toGroupId
});

export const swapUserWithPlaceholder = (fromGroupId, toGroupId) => ({
  type: types.SWAP_USER_WITH_PLACEHOLDER,
  fromGroupId,
  toGroupId
});
